import { useMutation } from '@tanstack/react-query'
import { githubCopy } from '@/copy'
import { Alert } from '@/ui/Alert/Alert'
import { Button } from '@/ui/Button/Button'
import { Inline } from '@/ui/layout/Inline'
import { startCentralInstall } from '../../utils/githubInstall'
import type { ViewResource } from '../resource-views/resourceViews'

/** The github connection's detail-page extra: reconnecting an App that was
 * uninstalled on GitHub. (The endpoint, what uses it and the delivery trace
 * are every connection's, rendered by the detail page.) */
export function GitHubConnectionPanels({
  resource,
}: {
  resource: ViewResource
}) {
  const workspaceId = resource.workspace_id
  const data = resource.data ?? {}
  const reconnect = useMutation({
    mutationFn: () => startCentralInstall(workspaceId ?? '', resource.id),
  })

  if (!workspaceId) return null
  if (data.central !== true || data.status !== 'disconnected') return null
  return (
    <Alert tone={reconnect.isError ? 'danger' : 'warning'}>
      <Inline gap="space-8" align="baseline" justify="between">
        {reconnect.isError
          ? githubCopy.connection.reconnectFailed(
              reconnect.error instanceof Error
                ? reconnect.error.message
                : String(reconnect.error),
            )
          : githubCopy.connection.disconnected}
        <Button
          variant="outline"
          loading={reconnect.isPending}
          onClick={() => reconnect.mutate()}
        >
          {githubCopy.connection.reconnect}
        </Button>
      </Inline>
    </Alert>
  )
}
